import React from 'react';
import { motion } from 'framer-motion';
import { usePrefersReducedMotion } from '../../hooks/useMedia';

/** Elegant three-dot thinking state for Morvix AI. */
export function TypingIndicator() {
  const reduced = usePrefersReducedMotion();
  return <div className="flex w-fit items-center gap-1.5 rounded-2xl rounded-tl-md border border-line bg-surface/70 px-4 py-3" role="status" aria-label="Morvix AI is typing" data-id="element-129" data-mp="3ov4hdbi6pf0x">
      {[0, 1, 2].map(index => <motion.span key={index} className="h-1.5 w-1.5 rounded-full bg-brand" initial={{
      opacity: 0.3
    }} animate={reduced ? {
      opacity: 0.6
    } : {
      opacity: [0.25, 1, 0.25],
      y: [0, -2, 0]
    }} transition={reduced ? {
      duration: 0
    } : {
      duration: 1.1,
      repeat: Infinity,
      delay: index * 0.14,
      ease: 'easeInOut'
    }} data-id="element-130" data-mp="3suvf5z64ovey" />)}
      <span className="label ml-1.5 text-muted" data-id="element-131" data-mp="28fjm48p7a2er">Thinking</span>
    </div>;
}